;(function () {
  const containerId = 'trusted-breweries-logos'

  const escapeHtml = (value) =>
    String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;')

  const shuffleInPlace = (items) => {
    for (let i = items.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1))
      const tmp = items[i]
      items[i] = items[j]
      items[j] = tmp
    }
    return items
  }

  const normalizeTeam = (team) => {
    if (!team || typeof team !== 'object') return null
    const name = typeof team.name === 'string' ? team.name.trim() : ''
    const logoUrl = typeof team.logoUrl === 'string' ? team.logoUrl.trim() : ''
    if (!name || !logoUrl) return null
    return { name, logoUrl, slug: typeof team.slug === 'string' ? team.slug.trim() : '' }
  }

  const render = (container, teams) => {
    const columns = teams
      .map((team) => {
        const alt = escapeHtml(team.name)
        const src = escapeHtml(team.logoUrl)
        return (
          '<div class="column is-2-desktop is-3-tablet is-4-mobile">' +
          `<img class="trusted-brewery-logo" loading="lazy" decoding="async" src="${src}" alt="${alt}" />` +
          '</div>'
        )
      })
      .join('')

    container.innerHTML =
      '<div class="columns is-multiline is-vcentered is-centered trusted-breweries-grid">' +
      columns +
      '</div>'
  }

  const init = async () => {
    const container = document.getElementById(containerId)
    if (!container) return

    if (!window.BrewskiConnector || typeof window.BrewskiConnector.getJson !== 'function') {
      container.textContent = ''
      return
    }

    container.innerHTML =
      '<p class="has-text-centered is-size-7 body-color">Loading trusted breweries…</p>'

    try {
      const payload = await window.BrewskiConnector.getJson('/public/teams')
      const teamsRaw = Array.isArray(payload?.teams) ? payload.teams : []
      const teams = teamsRaw.map(normalizeTeam).filter(Boolean)

      // Keep the section light: random subset.
      shuffleInPlace(teams)
      const selected = teams.slice(0, 18)

      if (selected.length === 0) {
        container.textContent = ''
        return
      }

      render(container, selected)
    } catch (error) {
      // Silent failure: marketing page should still render.
      container.textContent = ''
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init)
  } else {
    init()
  }
})()

